import { useState, useEffect } from 'react';
import InputMask from 'react-input-mask';
import ReactApexChart from 'react-apexcharts';
import ReactSelect from 'react-select';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';

const RankBusinessQuestion = () => {

    const convertToGregorian = date => date.year.toString() + (date.month > 9 ? date.month.toString() : ('0' + date.month)) + (date.day > 9 ? date.day.toString() : ('0' + date.day))

    const { readData: getReports } = useEntityCrud('Report/RankBaseQuestion');
    const { readData: getOpinions } = useEntityCrud('Opinions/getAll');
    const { readData: getGuilds } = useEntityCrud('Guild/GetAllGuilds');
    const { readData: getBusiness } = useEntityCrud('Business/GetAllBusiness');
    const { readData: getBranchs } = useEntityCrud('Branch/GetAllBranchs');

    const [opinions, setOpinions] = useState([]);
    const [guilds, setGuilds] = useState([]);
    const [businesses, setBusinesses] = useState([]);
    const [branchs, setBranchs] = useState([]);
    const [rows, setRows] = useState([]);
    const [options, setOptions] = useState({});


    const [opinion, setOpinion] = useState(0);
    const [branchId, setBranchId] = useState([]);
    const [guild, setGuild] = useState(0);
    const [business, setBusiness] = useState(0);

    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const [cityId,setCityId] = useState(0);
    const [provinceId,setProvinceId] = useState(0);
    const {readGetDataById: getProvinces} = useEntityCrud('Info/GetProvinces');
    const {readGetDataById: getCities} = useEntityCrud(`Info/GetCities?provinceId=${provinceId}`);
    const [provinces,setProvinces] = useState([]);
    const [cities,setCities] = useState([]);

    const [isSearched, setIsSearched] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [showItem, setShowItem] = useState(true);
    const [isAdvanced, setIsAdvanced] = useState(false);


    useEffect(() => {

        getBranchs().then(({ data }) => {
            let branchs = [];
            if (data.status)
                data.result.map(item => {
                    if (item.isActive)
                        branchs.push({
                            label: item.title,
                            value: item.id
                        });
                })
            setBranchs(branchs);
        })

        getGuilds().then(({ data }) => {
            let guildsArr = [];
            if (data.status)
                data.result.map(item => {
                    guildsArr.push({
                        label: item.title,
                        value: item.id
                    });
                })
            setGuilds(guildsArr);
        })
        getBusiness().then(({ data }) => {
            let businesses = [];
            if (data.status)
                data.result.map(item => {
                    // if (item.isActive) {
                        // if (!(businesses?.find(it => it.label === item.title))) {
                            businesses.push({
                                label: item.title,
                                value: item.id
                            });
                        // }
                    // }
                })
            setBusinesses(businesses);
        })
        getOpinions().then(({ data }) => {
            let opinionsArr = [];
            if (data.status)
                data.result.map(item => {
                    opinionsArr.push({
                        label: item.title,
                        value: item.id
                    });
                })
            setOpinions(opinionsArr);
        })
        getProvinces().then(({data}) => {
            let getProvinces = [];
            data.result.map(item => getProvinces.push({
                label: item.title,
                value: item.id
            }))
            setProvinces(getProvinces);
        })
    }, [])

    useEffect(() => {
        if(provinceId != 0)
            getCities().then(({data}) => {
                if(data.status){
                    let getCities = [];
                    data.result.map(item => getCities.push({
                        label: item.title,
                        value: item.id
                    }))
                    setCities(getCities);
                }
            });
    },[provinceId])


    const getReportsData = () => {

        setIsAdvanced(true);
        setLoading(true);
        setShowItem(false);

        const postedData = {
            p_opinion_id: opinion || 0,
            p_guild_id: guild || 0,
            p_business_id: business || 0,
            p_cityid: cityId,
            branchId: branchId
        };
        if(fromDate)
            postedData.p_fromdate = convertToGregorian(fromDate)
        if(toDate)
            postedData.p_todate = convertToGregorian(toDate)
        getReports(postedData).then(({ data }) => {
            setLoading(false)
            setShowItem(true);

            if (data.status && data.result) {
                const dataNew = data.result.v_result.reduce((acc, item) => {

                    if (acc[item.q_title]) {
                        return { ...acc, [item.q_title]: { ...acc[item.q_title], [`${item.bu_title} (${item.cnt_use || 0}) - (${item.full_satisfaction || 0})`]: item.avg_point } }
                    }
                    else {
                        return { ...acc, [item.q_title]: { [`${item.bu_title} (${item.cnt_use || 0}) - (${item.full_satisfaction || 0})`]: item.avg_point } }
                    }
                }, {})

                let categories = [];
                data.result.v_result.map(item => {
                    categories.push({
                        name: item.bu_title,
                        value: item.cnt_use
                    });
                })


                let cats = undefined;
                setRows(Object.keys(dataNew).map(function (name) {
                    if (!cats) {
                        cats = Object.keys(dataNew[name]);
                    }
                    return {
                        name,
                        data: [...Object.keys(dataNew[name])].map(item => dataNew[name][item])
                    };
                }))


                setOptions({

                    chart: {
                        type: 'bar',
                        height: 2000,
                        stacked: true,
                        fontSize: "8px"
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                        }
                    },
                    colors: ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
                        '#f48024', '#69d2e7'
                    ],
                    dataLabels: {
                        enabled: true,
                        offsetX: 0,
                        style: {
                            fontSize: '12px',
                            colors: ['#fff']
                        }
                    },
                    tooltip: {
                        shared: true,
                        intersect: false
                    },
                    stroke: {
                        show: true,
                        width: 1,
                        colors: ['#fff']
                    },
                    xaxis: {
                        categories: cats,
                        labels: {
                            formatter: function (val) {
                                return ""
                            },
                            style: {
                                fontSize: '8px !important'
                            }
                        }
                    },
                    legend: {
                        position: 'top',
                        horizontalAlign: 'center',
                        offsetX: 10
                    }
                });

            } else
                setRows([]);
        }).finally(() => {
            setIsSearched(true);
        })
    }


    const advancedSearch = e => {
        e.preventDefault();
        getReportsData();
        setIsAdvanced(true);
    }

    const resetAdvancedSearch = e => {
        e.preventDefault();
        setIsAdvanced(false);
        setIsSearched(false)

        setOpinion(0)
        setBranchId([])

        setOptions({});
        setRows({})

    }


    return (
        <div className="row">

            <div className="row pb-4">
                <div className="col-md-2">
                    <div className="form-group">
                        {opinion ? <i className="fe fe-x clear-select-btn" onClick={e => setOpinion(0)}></i> : ''}
                        <label>نظرسنجی</label>
                        <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" options={opinions}
                            value={opinions.filter(b => b.value == opinion)}
                            onChange={e => setOpinion(e.value)} />
                    </div>
                </div>


                <div className="col-md-2">
                    <label>شرکت زیر مجموعه</label>
                    <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" options={branchs} isMulti={true} value={branchs.filter(item => branchId.includes(item.value))} onChange={e => setBranchId([...e.map(i => i.value)])} />
                </div>
                <div className="col-md-2">
                    <div className="form-group">
                        <label>استان</label>
                        <ReactSelect noOptionsMessage={e => 'یافت نشد'} placeholder="انتخاب کنید" options={provinces} value={provinces.filter(item => item.value == provinceId)} onChange={e => setProvinceId(e.value)} />
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="form-group">
                        <label>شهر</label>
                        <ReactSelect noOptionsMessage={e => 'یافت نشد'} disabled={!provinces.length} placeholder="انتخاب کنید" isDisabled={!cities.length} options={cities} value={cities.filter(item => item.value == cityId)} onChange={e => setCityId(e.value)} />
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="form-group">
                        <label>از تاریخ</label>
                        {fromDate && <i class="fe fe-x clear-select-btn" onClick={() => setFromDate(null)} style={{left: 25}}></i>}
                        <DatePicker
                            name="fromDate"
                            required
                            locale="fa"
                            shouldHighlightWeekends
                            value={fromDate}
                            onChange={setFromDate}
                            className="form-control"
                            inputPlaceholder='تاریخ  را انتخاب کنید ...'
                        />
                    </div>
                </div>
                <div className="col-md-2">
                    <div className="form-group">
                        <label>از تاریخ</label>
                        {toDate && <i class="fe fe-x clear-select-btn" onClick={() => setToDate(null)} style={{left: 25}}></i>}
                        <DatePicker
                            name="toDate"
                            required
                            locale="fa"
                            shouldHighlightWeekends
                            value={toDate}
                            onChange={setToDate}
                            className="form-control"
                            inputPlaceholder='تاریخ  را انتخاب کنید ...'
                        />
                    </div>
                </div>

                <div className="py-2 col-md-2" style={{ marginTop: 25, textAlign: "center" }}>
                    {showItem && <> <button className="btn btn-primary" onClick={advancedSearch}>جستجو</button>
                        {isAdvanced &&
                            <button className="btn btn-danger mx-2" onClick={resetAdvancedSearch}>حذف فیلتر</button>
                        }
                    </>
                    }
                </div>



            </div>


            {isLoading ?

                <div class="lds-facebook">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>

                :

                <>

                    {rows.length ? <div className="col-md-12 mt-3">
                        <div id="chart" dir='ltr'>
                            <ReactApexChart options={options} series={rows} type="bar" height={2000} />
                        </div>
                    </div> : (isSearched ? <div className="col-md-12 mt-2">
                        <div className="alert alert-primary"><p>داده ای جهت نمایش یافت نشد</p></div>
                    </div> : '')}

                </>
            }

        </div>
    )
}

export default RankBusinessQuestion;